import React, { Suspense, lazy } from "react";
import * as styles from "./HeroWrapper.module.css";
import { HeroHeights, HeroStyles, Image } from "../../../types";
import { ArtDirectedImageElement } from "../../elements/KontentImageElement/ArtDirectedImageElement";
import { OverlayStyle } from "../../blocks/DynamicHero/MediaDynamicHero";
import { LoadingTile } from "../LoadingTile/LoadingTile";
const ReactPlayer = lazy(() => import("react-player/lazy"));

export interface MediaHeroProps {
  desktopImage?: Image;
  mobileImage?: Image;
  videoUrl?: string;
  style?: HeroStyles;
  height?: HeroHeights;
  overlayStyle?: OverlayStyle;
}

export const MediaHeroWrapper: React.FC<MediaHeroProps> = ({
  desktopImage,
  mobileImage,
  videoUrl,
  style,
  height,
  overlayStyle = "gradient",
  ...props
}) => {
  const containerClasses = [styles.hero];
  const overlayClasses = [styles.overlay];

  height === "tall"
    ? containerClasses.push(styles.tall)
    : containerClasses.push(styles.short);

  style === "media_dark_text" && containerClasses.push(styles.darkText);

  if (overlayStyle === "solid") {
    overlayClasses.push(styles.overlaySolid);
  }

  if (overlayStyle === "gradientLeft") {
    overlayClasses.push(styles.gradientLeft);
  }

  const renderMedia = () => {
    if (videoUrl) {
      return (
        <div className={styles.heroVideoWrapper}>
          <Suspense fallback={<LoadingTile />}>
            <ReactPlayer
              url={videoUrl}
              playing
              muted
              loop
              playsinline
              width="2500px"
              height={height === "tall" ? "700px" : "363px"}
              controls={false}
              config={{
                vimeo: {
                  playerOptions: {
                    background: true,
                    responsive: true,
                  },
                },
              }}
              className={styles.heroVideo}
            />
          </Suspense>
        </div>
      );
    }

    if (!desktopImage?.item) return;

    return (
      <ArtDirectedImageElement
        mobileImage={
          mobileImage?.item
            ? {
                image: mobileImage?.item,
                width: 576,
                height: 432,
                layout: "fullWidth",
                backgroundColor: "#bbbbbb",
                aspectRatio: 576 / 432,
              }
            : undefined
        }
        desktopImage={{
          image: desktopImage.item,
          width: 1920,
          height: 649,
          layout: "fullWidth",
          backgroundColor: "#bbbbbb",
          aspectRatio: 2500 / 845,
        }}
        className={styles.artDirected}
        focalPoint={desktopImage?.focalPoint}
      />
    );
  };

  return (
    <div className={containerClasses.join(" ")}>
      <div className={overlayClasses.join(" ")}></div>
      {renderMedia()}
      <div className={styles.heroContentWrap}>{props.children}</div>
    </div>
  );
};
